/**
 * Retrieves the name of the audit log history action value
 *
 * @param objectToMap { sym: { name: string } }
 * @returns {string}
 */
export const getDefaultAuditLogNameMapFunc = (objectToMap) => objectToMap?.sym?.name || objectToMap;
